import { render, staticRenderFns } from "./chip-primary.vue?vue&type=template&id=61516986&scoped=true&"
import script from "./chip-primary.vue?vue&type=script&lang=js&"
export * from "./chip-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61516986",
  null
  
)

export default component.exports